// extracted by mini-css-extract-plugin
export default {"file-info":"Ilx8ktHY7zUSOKq","full-name":"qIzWdMR9qd4Re3W","file-name":"ZvF_hHEaa0mjvwH","file-errors":"zRTAhJ3uhoAsIvF","file-error":"ZsS8VogQexHMLti"};